import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Canvas from './components/Canvas';
import NavigationDrawer from './components/NavigationDrawer';
import { traitCollections } from './config/stepsConfig';

function Builder(props) {    
    const theSize = props.size;
    const [activeCollection, setActiveCollection] = useState('default');
    
    // Get current collection data
    const currentCollection = traitCollections.find(c => c.id === activeCollection);
    const stepsData = currentCollection.stepsData;

    // Initialize selectedOptions dynamically from current collection's stepsData
    // Set the first background option as default
    const initialSelectedOptions = Object.fromEntries(
        stepsData.map(step => {
            if (step.stepName.toLowerCase() === 'background') {
                // Set the first background option as default
                return [step.stepName.toLowerCase(), step.options[0]];
            }
            return [step.stepName.toLowerCase(), null];
        })
    );

    const [currentStep, setCurrentStep] = useState(1);
    const [selectedOptions, setSelectedOptions] = useState(initialSelectedOptions);
    const [isCollectionOpen, setIsCollectionOpen] = useState({
        default: true,
        halloween: false
    });

    const totalSteps = stepsData.length;

    const handleStepChange = (stepIndex) => {
        setCurrentStep(stepIndex + 1);
    };

    const handleCollectionChange = (collectionId) => {
        setActiveCollection(collectionId);
        setCurrentStep(1);
        
        const newCollection = traitCollections.find(c => c.id === collectionId);
        const newSelectedOptions = Object.fromEntries(
            newCollection.stepsData.map(step => {
                if (step.stepName.toLowerCase() === 'background') {
                    // Set the first background option as default
                    return [step.stepName.toLowerCase(), step.options[0]];
                }
                return [step.stepName.toLowerCase(), null];
            })
        );
        
        setSelectedOptions(newSelectedOptions);
        setIsCollectionOpen(prev => ({
            ...Object.fromEntries(traitCollections.map(c => [c.id, false])),
            [collectionId]: true
        }));
    };

    const handleOptionSelect = (stepName, option) => {
        setSelectedOptions((prevOptions) => ({
            ...prevOptions,
            [stepName.toLowerCase()]: option,
        }));
    };

    const handleRandomize = () => {
        const randomizedOptions = {};
        
        stepsData.forEach(step => {
            if (step.options && step.options.length > 0) {
                let optionsToUse = step.options;
                
                // For Head trait, only use options that start with "Cloudy"
                if (step.stepName.toLowerCase() === 'head') {
                    optionsToUse = step.options.filter(option => 
                        option.name.toLowerCase().startsWith('cloudy')
                    );
                }
                
                // Get a random option from the filtered options
                if (optionsToUse.length > 0) {
                    const randomIndex = Math.floor(Math.random() * optionsToUse.length);
                    randomizedOptions[step.stepName.toLowerCase()] = optionsToUse[randomIndex];
                }
            }
        });
        
        setSelectedOptions(randomizedOptions);
    };

    const handlePreviousStep = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    };

    const handleNextStep = () => {
        if (currentStep < totalSteps) {
            setCurrentStep(currentStep + 1);
        }
    };

    const currentStepData = stepsData.find((step) => step.num === currentStep) || {
        title: '',
        options: [],
    };

    return (
        <div className="flex relative">
            <Toaster />
            
            <NavigationDrawer 
                stepsData={stepsData}
                onStepChange={handleStepChange}
                currentStep={currentStep}
                selectedOptions={selectedOptions}
                activeCollection={activeCollection}
                isCollectionOpen={isCollectionOpen}
                onCollectionChange={handleCollectionChange}
                onOptionSelect={handleOptionSelect}
                currentStepData={currentStepData}
                totalSteps={totalSteps}
                collectionId={activeCollection}
                handlePreviousStep={handlePreviousStep}
                handleNextStep={handleNextStep}
            />

            <div className="flex-grow w-[calc(100%-130px)] lg:w-[calc(100%-200px)] flex flex-col p-5 lg:p-10 text-center justify-start items-center">
                <Canvas 
                    totalSteps={totalSteps}
                    currentStep={currentStep}
                    onRandomize={handleRandomize}
                    theSize={theSize}
                    initialSelectedOptions={initialSelectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    selectedOptions={selectedOptions}
                    stepsData={stepsData}
                    collectionId={activeCollection}
                />
            </div>
        </div>
    );
}

export default Builder;
